import { render } from "./AnimatedNumber.vue?vue&type=template&id=2d5d1f75"
import script from "./AnimatedNumber.vue?vue&type=script&lang=js"
export * from "./AnimatedNumber.vue?vue&type=script&lang=js"
script.render = render

export default script